export default class Globals {
  static MIN_YEAR = 2008;
  static MAX_YEAR = 2025;

  // Enable to preload loading of next track.
  static ENABLE_NEXT_TRACK_PRELOAD = true;
  static NEXT_TRACK_PRELOAD_SECONDS = 10;

  // Enable to change background/text color based on album.
  static ENABLE_DYNAMIC_COLORS = false;

  // Enable to use a test 5 second audio file.
  static TEST_AUDIO = false;
}